import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8fa487d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "audio-spectrogram" }

import {computed, onMounted, onUnmounted, ref, watch} from 'vue'
  import {useStore} from 'vuex'

  import spectrogram from '@/lib/spectrogram'
  import chroma from 'chroma-js'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AudioSpectrogram',
  props: {
    audio: null
  },
  emits: ['audio-started', 'audio-ended'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
    audio: string
  };

  const store = useStore()

  

  

  expose({currentTime, iosAwaitingUserInteraction, iosPlay, drawLine})

  const canvas = ref<HTMLCanvasElement>()
  const spectro = ref(null)
  const audioContext = new AudioContext()
  audioContext.suspend()

  const baseColors = [
    chroma('#000D1A'),
    chroma('#5DA4DA'),
    chroma('#E32B97'),
    chroma('#FF725F')
  ]

  let paused = false
  const updateEveryFrame = () => {
    if (spectro.value) console.log('updateEveryFrame', currentTime())
    req = requestAnimationFrame(updateEveryFrame)
  }

  let req = null
  onMounted(() => {
    req = requestAnimationFrame(updateEveryFrame)
  })

  onUnmounted(() => {
    resetSpectrogram()

    cancelAnimationFrame(req)
  })

  watch(
    () => props.audio,
    () => {
      initSpectrogram()
      startSpectrogram()
    }
  )

  const muted = computed(() => store.state.muted)

  watch(muted, (value) => spectro.value.setAudioEnabled(!value))

  function initSpectrogram() {
    spectro.value = spectrogram(canvas.value, {
      audio: {
        enable: !muted.value
      },
      canvas: {
        width: window.innerWidth,
        height: window.innerHeight
      },
      colors: generateColors
    })
  }

  function startSpectrogram() {
    // Reset the spectrogram if changing audio
    resetSpectrogram()

    // Load the new audio
    const fetchAudio = async (path) => {
      const xhr = await fetch(path)
      const arrayBuffer = await xhr.arrayBuffer()
      return arrayBuffer
    }

    // Decode audio and start spectrogram
    fetchAudio(props.audio).then((arrayBuffer) => {
      audioContext.decodeAudioData(arrayBuffer, function (audioBuffer) {
        audioContext.resume()

        spectro.value.connectSource(audioBuffer, audioContext)
        modifyAudioBuffer()
        spectro.value.start()
        emit('audio-started')
      })
    })
  }

  function drawLine() {
    spectro.value.addLine(spectro.value.getCurrentXPos())
  }

  function resetSpectrogram() {
    if (spectro.value?._sources?.audioBufferStream) {
      spectro.value.stop()
      spectro.value.clear()
    }
  }

  function modifyAudioBuffer() {
    if (spectro.value?._sources?.audioBufferStream) {
      spectro.value._sources.audioBufferStream.analyser.fftSize = 2048
      spectro.value._sources.audioBufferStream.sourceNode.onended = function () {
        emit('audio-ended')
      }
    }
  }

  function generateColors(steps) {
    const positions = [...Array(baseColors.length).keys()].map(
      (i) => (i + 1) / baseColors.length
    ) // Evenly spaced

    const scale = new chroma.scale(baseColors, positions).domain([0, steps])

    const colors = []

    for (let i = 0; i < steps; ++i) {
      const color = scale(i)
      colors.push(color.hex())
    }

    return colors
  }

  function currentTime() {
    return Math.round(audioContext.currentTime * 1000)
  }

  function iosAwaitingUserInteraction() {
    return audioContext.state === 'suspended'
  }

  function iosPlay() {
    if (audioContext.state === 'suspended') {
      audioContext.resume()
    }
  }

  const globalPaused = computed(() => store.state.paused)

  watch(globalPaused, (value) => {
    if (value) {
      audioContext.suspend()
    } else {
      audioContext.resume()
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("canvas", {
      ref_key: "canvas",
      ref: canvas,
      class: "canvas"
    }, null, 512)
  ]))
}
}

})